import axios from "axios";
import {ContentStateType} from "../state/ContentState";
import { appInsights } from "./AppInsights";
import {useEffect, useState} from "react";
import initialContentState from "../state/ContentState";

const API_URL= process.env.REACT_APP_MPACTIVITY_BFF_CMS_URL as string;
const API_KEY = process.env.REACT_APP_APIM_KEY;

const ContentService = () => {
    let [contentState, setContentState] = useState(initialContentState);
    let [contentLoaded, setContentLoaded] = useState(false);
    const Content = async () => {
        const headers = {
            'Authorization': 'Bearer ACCESS_TOKEN',
            'Content-Type': 'application/json',
            "Ocp-Apim-Subscription-Key": API_KEY,
        };
        try {
            const contentResponse = await axios.get(API_URL, {headers, timeout: 30000});
            const content = contentResponse.data as ContentStateType;
            setContentState(content);

        } catch (error) {
            appInsights?.trackException({ exception: error as Error });
        } finally {
            setContentLoaded(true);
        }
    };
    useEffect(() => {
        Content();
    }, []);
    return {
        contentState,
        contentLoaded
    };
}


export default ContentService;